<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/modules/plugins/modules/event'
export default {
    name: 'Overlay',
    computed: {
        ...mapGetters([
            'overlayModal',
            'overlayDropdown',
            'modalsOpen',
            'blockOverlay',
            'smDevice',
            'visibleDropdownOverlay',
        ]),
    },
    methods: {
        clickOverlayDropdown() {
            if (this.smDevice) EventBus.$emit('closeDropdown')
        },
        clickOverlayModal() {
            if (!this.blockOverlay && this.modalsOpen.length) EventBus.$emit('closeAllModals')
        },
    },
}
</script>

<template lang="pug">
lazy-component.overlay-wrapper
    transition(name="overlay-fade")
        .overlay.overlay-dropdown(@click="clickOverlayDropdown" :class="{'overlay-transparent': !visibleDropdownOverlay}" v-if="overlayDropdown")
    transition(name="overlay-fade")
        .overlay.overlay-modal(@click="clickOverlayModal" v-if="overlayModal")
</template>
